import styled, { keyframes } from 'styled-components';
import { Collapse } from 'antd';

export const CollapseContainer = styled.div`
  width: 100%;
  &&& {
    .ant-collapse > .ant-collapse-item:last-child,
    .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
      text-align: center;
    }

    .ant-collapse > .ant-collapse-item:last-child,
    .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
      display: inline-block;
      padding: 0;
      color: #943fa1;
    }

    .ant-collapse-ghost {
      text-align: center;
    }

    .ant-collapse-icon-position-right
      > .ant-collapse-item
      > .ant-collapse-header
      .ant-collapse-arrow {
      right: -17px;
      top: 29%;
    }

    .ant-collapse
      > .ant-collapse-item
      > .ant-collapse-header
      .ant-collapse-arrow
      svg {
      fill: #943fa1;
    }
  }
`;

const slideInAnimation = keyframes`
   0% {
      height: 0
    }
    100% {
      height: 700px;
    }
`;

const slideOutAnimation = keyframes`
   0% {
    height: 810px;
    }
    100% {
      height: 0
    }
`;

export const WhyUsContainer = styled.div`
  .hs-open {
    height: 700px;
    animation: ${slideInAnimation} 0.5s ease;
    overflow: hidden;
  }

  .hs-close {
    height: 0;
    overflow: hidden;
    animation: ${slideOutAnimation} 0.5s ease;
  }
`;
